const VERIFICATION_STATUS_VALIDATED = "validated";

export const getIsStatusValidated = (status?: string): boolean => status === VERIFICATION_STATUS_VALIDATED;
